import { PageType } from "@product/scmp-sdk";

import type { LinkEntity } from "shared/components/common/base-entity-link/types";

import { pathname as postiesEventsPathname } from "scmp-app/pages/posties/events";
import { pathname as postiesVideoPathname } from "scmp-app/pages/posties/video";

export type FooterMenuData = Item[];

type Item = LinkEntity & {
  isBold?: boolean;
  isLargeSpacing?: boolean;
};

export const footerMenuData: FooterMenuData[] = [
  [
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      isLargeSpacing: true,
      name: "Video",
      query: {
        pageType: PageType.PostiesVideo,
      },
      urlAlias: postiesVideoPathname,
    },
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      isLargeSpacing: true,
      name: "ePaper",
      urlAlias: "/epaper/posties",
    },
  ],
  [
    {
      entityId: "",
      isLargeSpacing: true,
      name: "Subscribe",
      urlAlias: "https://subscribe.scmp.com/posties",
    },
    {
      entityId: "",
      entityUuid: "",
      isLargeSpacing: true,
      name: "Events",
      query: {
        pageType: PageType.PostiesEvents,
      },
      urlAlias: postiesEventsPathname,
    },
    {
      entityId: "",
      entityUuid: "",
      isLargeSpacing: true,
      name: "About us",
      routeType: "Static",
      urlAlias: "/posties/about-us",
    },
    {
      entityId: "",
      entityUuid: "",
      isLargeSpacing: true,
      name: "Learn",
      routeType: "Static",
      urlAlias: "https://www.scmplearn.com/",
    },
    {
      entityId: "",
      entityUuid: "",
      isLargeSpacing: true,
      name: "Contact us",
      routeType: "Static",
      urlAlias: "/posties/contact-us",
    },
    {
      entityId: "800172",
      entityUuid: "d1c18b93-cb6c-48a2-bf84-7c2acb96d4cc",
      isLargeSpacing: true,
      name: "Privacy Policy",
      routeType: "Page",
      urlAlias: "/privacy-policy",
    },
    {
      entityId: "800173",
      entityUuid: "c18b91b9-6e24-45dc-ba05-974848666e4b",
      isLargeSpacing: true,
      name: "Terms & Conditions",
      routeType: "Page",
      urlAlias: "/terms-conditions",
    },
  ],
];
